import{isHidden as r}from"../utils/element.js";var e=function(e){if(r(e))return 1/0;for(var t=0,n=e.parentNode;n;)t+=1,n=n.parentNode;return t};export{e as calculateDepthForNode};
//# sourceMappingURL=calculateDepthForNode.js.map
